import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcDatePicker } from 'components/MprcDatePicker';
import { Formaters } from 'lib/Formaters';
import moment, { Moment } from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IAdvFilterCommand, IAdvFilterPickerProps, IAdvFilterResult } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const PeriodPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;

    const { t } = useTranslation("knowledge");
    const inputRef = useRef<HTMLInputElement | undefined>(undefined);
    const [startDate, setStartDate] = useState<Moment | null>(null);
    const [endDate, setEndDate] = useState<Moment | null>(null);

    const canApply = (!!startDate && startDate.isValid()) || (!!endDate && endDate.isValid());

    ////////////////////////////////////////////////////////////////////////////////

    ///
    function getDisplayText(command: IAdvFilterCommand, startOn: Date | null, endOn?: Date | null): string {
        if (startOn == null && endOn == null) throw "Invalid dates";

        const period = startOn != null && endOn != null
            ? `${Formaters.dayMonth(startOn)} ${t("Feed.AdvancedFilter.UntilText")} ${Formaters.dayMonth(endOn)}`
            : startOn != null
                ? `${t("Feed.AdvancedFilter.FromText")} ${Formaters.dayMonth(startOn)}`
                : `${t("Feed.AdvancedFilter.UntilText")} ${Formaters.dayMonth(endOn)}`;

        return filter.displayPreText != undefined
            ? `${filter.displayPreText}: ${period}`
            : period;
    }

    ///
    const handleApply = () => {

        var sDate = startDate != null && startDate.isValid() ? startDate : null;
        var eDate = endDate != null && endDate.isValid() ? endDate : null;

        const newFilter = {
            command: filter.command,
            text: getDisplayText(filter, sDate?.toDate() ?? null, eDate?.toDate() ?? null),
            period: { startDate: sDate?.startOf("day").toDate() ?? null, endDate: eDate?.endOf("day").toDate() ?? null }
        } as IAdvFilterResult;

        onApply(newFilter, filter);
    };

    useEffect(() => {
        inputRef.current?.focus();
    }, [inputRef]);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <Grid container spacing={4}>
                    <Grid>
                        <MprcDatePicker
                            label={t("Feed.AdvancedFilter.FromLabel")}
                            autoFocus
                            value={startDate?.toDate() ?? null}
                            onChange={(date) => setStartDate(moment(date))}
                            color="warning"
                        />
                    </Grid>
                    <Grid>
                        <MprcDatePicker
                            label={t("Feed.AdvancedFilter.ToLabel")}
                            value={endDate?.toDate() ?? null}
                            onChange={(date) => setEndDate(moment(date))}
                            color="warning"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={!canApply}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
